import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { switchUserTournament } from 'modules/auth/store/actions';
import { ChampionshipFilterItem } from '../domain/interfaces/championship';
import { MonthRef } from '../domain/utils/calendar-months';

/** Только состояние интерфейса: матчи месяцев живут в кеше RTK Query (`schedule-api.ts`). */
export type ScheduleSliceState = {
  /** Выбранный день, ISO. Матчи под календарём — этого дня. */
  selectedDate: string;
  /** Первый из показанных рядом месяцев (0–11 и год). */
  currentMonth: number;
  currentYear: number;

  /** Выбранные в фильтре турниры; пусто — все. */
  championshipFilter: ChampionshipFilterItem[];
};

const now = new Date();

const initialState: ScheduleSliceState = {
  selectedDate: now.toISOString(),
  currentMonth: now.getMonth(),
  currentYear: now.getFullYear(),

  championshipFilter: [],
};

const slice = createSlice({
  name: 'schedule',
  initialState,
  extraReducers: (builder) => {
    // Организацию меняют на другой странице, и расписание при этом размонтируется: сброс не может жить в эффекте страницы.
    // Турниры прежней организации у новой ничего не значат — фильтр очищается самим действием смены.
    builder.addCase(switchUserTournament, (state) => {
      state.championshipFilter = [];
    });
  },
  reducers: {
    /** Первый показанный месяц: стрелки и «Сегодня». */
    setCurrentDate: (state, action: PayloadAction<MonthRef>) => {
      state.currentMonth = action.payload.month;
      state.currentYear = action.payload.year;
    },
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
    setChampionshipFilter: (state, action: PayloadAction<ChampionshipFilterItem[]>) => {
      state.championshipFilter = action.payload;
    },
  },
});

const scheduleReducer = slice.reducer;
export const { setCurrentDate, setSelectedDate, setChampionshipFilter } = slice.actions;
export default scheduleReducer;
